import "./App.scss"
import React, { Component } from "react"
import { authStore, productStore } from "./stores"
import { Switch, Redirect } from "react-router"
import { BrowserRouter, Route, Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Icon, AppHeader, AppPanel, AppSidebar } from "./lib"
import styled from "styled-components"
import Storefront from "./storefront/Storefront"
import Products from "./products/Products"
import OrderList from "./orders/OrderList"
import Orders from "./orders/Orders"
import Dashboard from "./Dashboard"
import Payment from "./Payment"

@observer
class App extends Component {
  render() {
    const { authenticated, authenticating, loading } = authStore
    if (loading) {
      return null
    }
    return (
      <BrowserRouter>
        <div className={authenticated ? "App Authenticated" : "App"}>
          {authenticated ? (
            <div className="App_container">
              <AppSidebar />
              <div className="App_wrapper">
                <Switch>
                  <Route path="/dashboard" component={Dashboard} />
                  <Route path="/products" component={Products} />
                  <Route path="/orders" component={Orders} />
                  <Route path="/store" component={Storefront} />
                  <Route path="/embed" component={Embed} />
                  <Route path="/payment" component={Payment} />
                  <Route render={() => <Redirect to="/dashboard" />} />
                </Switch>
              </div>
            </div>
          ) : (
            <div>
              <Switch>
                <Route path="/sign-up" exact component={SignUp} />
                <Route path="/sign-in" exact component={SignIn} />
                <Route render={() => <Redirect to="/sign-up" />} />
              </Switch>
            </div>
          )}
        </div>
      </BrowserRouter>
    )
  }
}

@observer
class SignUp extends Component {
  state = {
    email: "",
    password: "",
    storeName: "",
  }
  createAccount = () => {
    var { email, password, storeName } = this.state

    authStore.createAccount(email, password, storeName)
  }
  render() {
    var { email, password, storeName } = this.state

    return (
      <div className="form" style={{ textAlign: "center" }}>
        <img src="/tinymerch-icon.png" style={{ width: 60, marginTop: 20 }} />
        <h1 style={{ marginBottom: 35, marginTop: 10, fontSize: 20 }}>
          Create your free TinyMerch account!
        </h1>
        <fieldset>
          <div className="row" label="Store Name">
            <input
              placeholder="Jane's Art"
              value={storeName}
              onChange={e =>
                this.setState({ storeName: e.currentTarget.value })}
            />
          </div>
          <div className="row" label="Email">
            <input
              value={email}
              placeholder="jane@example.com"
              onChange={e => this.setState({ email: e.currentTarget.value })}
            />
          </div>

          <div className="row" label="Password">
            <input
              type="password"
              value={password}
              placeholder="*******"
              onChange={e => this.setState({ password: e.currentTarget.value })}
              onKeyPress={e => {
                if (e.key === "Enter") {
                  this.createAccount()
                }
              }}
            />
          </div>
        </fieldset>
        <p className="error">{authStore.signUpErrorMessage}</p>

        <button onClick={this.createAccount}>Next: Set up your store</button>

        <p
          style={{
            fontStyle: "italic",
            fontSize: 14,
            color: "rgba(0,0,0,0.5)",
          }}>
          If you already have a TinyMerch account,{" "}
          <Link to="/sign-in">sign in.</Link>
        </p>
      </div>
    )
  }
}

@observer
class SignIn extends Component {
  state = {
    email: "",
    password: "",
    storeName: "",
  }
  signIn = () => {
    authStore.signIn(this.state.email, this.state.password)
  }
  render() {
    var { email, password, storeName } = this.state
    return (
      <div className="form" style={{ textAlign: "center" }}>
        <img src="/tinymerch-icon.png" style={{ width: 60, marginTop: 20 }} />
        <h1 style={{ marginBottom: 35, marginTop: 10, fontSize: 20 }}>
          Sign in to your TinyMerch dashboard.
        </h1>

        <fieldset>
          <div className="row" label="Email">
            <input
              value={email}
              placeholder="jane@example.com"
              onChange={e => this.setState({ email: e.currentTarget.value })}
            />
          </div>

          <div className="row" label="Password">
            <input
              type="password"
              value={password}
              placeholder="*******"
              onKeyPress={e => {
                if (e.key === "Enter") {
                  this.signIn()
                }
              }}
              onChange={e => this.setState({ password: e.currentTarget.value })}
            />
          </div>
        </fieldset>
        <p className="error">{authStore.signInErrorMessage}</p>
        <button onClick={this.signIn}>Sign in</button>
        <p
          style={{
            fontStyle: "italic",
            fontSize: 14,
            color: "rgba(0,0,0,0.5)",
          }}>
          Don't have a TinyMerch store yet?{" "}
          <Link to="/sign-up">Sign up for free.</Link>
        </p>
      </div>
    )
  }
}

@observer
class Embed extends Component {
  render() {
    return (
      <div>
        <AppHeader>
          <h1>Your Widget Embed</h1>
        </AppHeader>
        <AppPanel>
          <p style={{ padding: "20px 0" }}>
            Copy this script and paste it inside the body tag of your website.
          </p>

          {authStore.store ? (
            <pre
              style={{
                padding: 20,
                background: "#F2F2F7",
                borderRadius: 6,
              }}>
              {`<script src="https://embed.tinymerch.com/${authStore.store
                .storeName}.js" async></script>`}
            </pre>
          ) : null}
        </AppPanel>
      </div>
    )
  }
}

const NoMatch = ({ location, match }) => (
  <div className="NoMatch">
    <div className="NoMatch_info">
      <p>Sorry but {location.pathname} didn’t match any pages</p>
    </div>
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js